import { pxArrayToRem, pxToRem, type StyleRule } from '@archipro-design/aria';

export const MoreProductComing: StyleRule<{ columns: number }> = ({
    theme,
    columns,
}) => ({
    gridColumn: `1/${columns + 1}`,
    borderTop: '1px solid #1a1919',
    padding: pxArrayToRem([15, 0]),

    [theme.screen.laptop]: {
        padding: pxArrayToRem([51, 0]),
    },
});

export const Message: StyleRule = ({ theme }) => ({
    lineHeight: pxToRem(17),
    color: 'rgba(110, 110, 113, 0.93)',
    paddingTop: theme.siteVariables.spaces['space-16'],
    '& u': {
        cursor: 'pointer',
    },
    [theme.screen.laptop]: {
        paddingTop: theme.siteVariables.spaces['space-24'],
        color: theme.siteVariables.colors.charcoal[250],
        lineHeight: pxToRem(19.2),
    },
});
